// extracted by extract-css-chunks-webpack-plugin
module.exports = {"iframe":"_3O7uWa aLs3Nr","isLoaded":"_28mw4t","spinnerContainer":"_1ONeFu"};